export * from './FAQList'
export { default } from './FAQList'
